import firebase from 'firebase/app';
import 'firebase/storage';
import { buildConfig } from '../config';
import { fakeVideos, localFakeVideos, npcVideos } from './fakeVideos';

const config = buildConfig(process.env);

if (!firebase.apps.length) {
  firebase.initializeApp(config.firebase);
}

export const storage = firebase.storage();

if (config.firebase.storage.local) {
  storage.useEmulator(config.firebase.storage.host, config.firebase.storage.port);
}

let currentVideoId = 0;

export default class StorageService {
  storage: firebase.storage.Storage;
  storageReference: firebase.storage.Reference;
  constructor() {
    this.storage = storage;
    this.storageReference = this.storage.ref();
  }

  async getRandomFakeVideoDownloadUrl() {
    let videos = npcVideos;
    if (config.firebase.storage.local) {
      return null;
      // videos = localFakeVideos;
    }
    const fakeVideoId = currentVideoId % (videos.length - 1);
    currentVideoId++;
    const fakeVideoTitle = videos[fakeVideoId];
    const reference = this.storageReference.child(`demo/${fakeVideoTitle}`);
    return reference.getDownloadURL();
  }
}
